import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import config from '../../../config';
import { selectApiToken } from '../../auth/authSlice';
import {
  ScanDataStatusEnum,
  selectCurrScanID,
  setScanDataStatus,
} from '../../select/selectSlice';

const WRANGLER_API_URL = config.api.wranglerUrl;
const fileName = '000.parquet'; // Used to need to fetch manifest to get this, but now it's always 000.parquet

export const useFetchScanData = () => {
  const dispatch = useAppDispatch();
  const access_token = useAppSelector(selectApiToken);
  const currScanId = useAppSelector(selectCurrScanID);

  const [scanData, setScanData] = useState<File | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setScanDataStatus(ScanDataStatusEnum.loading));

      const headers = new Headers();
      if (access_token) {
        headers.append('Authorization', `Bearer ${access_token}`);
      }
      headers.append('Content-Type', 'application/json');

      try {
        const response = await fetch(
          `${WRANGLER_API_URL}v1/scandata`,
          {
            method: 'POST',
            headers,
            body: JSON.stringify({
              meta: {
                format: 'parquet'
              },
              data: {
                scan_id: currScanId
              }
            }),
            cache: 'no-cache',
          }
        );
        if (!response.ok) {
          throw new Error(await response.text());
        }

        const data = await response.arrayBuffer();
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const file = new File([blob], fileName, {
          type: 'application/octet-stream',
        });

        setScanData(file);
        dispatch(setScanDataStatus(ScanDataStatusEnum.success));
      } catch (err) {
        console.error('Error fetching scan data:', err);
        dispatch(setScanDataStatus(ScanDataStatusEnum.error));
        setScanData(null);
      }
    };

    if (currScanId && access_token) {
      fetchData();
    } else {
      setScanData(null);
    }
  }, [currScanId, access_token]);

  return scanData;
};
